import apiBase from "./apiBase";
//const simplePostAsync = apiBase.simplePostAsync;

export async function getVenomProteins() {
    const result = await apiBase.simpleGetAsync("/venomanalysis/proteins");

    return result.data;
}

export async function saveVenomAnalysis(analysis) {
    const result = await apiBase.simplePostAsync("/venomanalysis", analysis);

    return result.data;
}

export async function editVenomAnalysis(analysis) {
    const result = await apiBase.simplePostAsync("/venomanalysis/edit", analysis);

    return result.data;
}

export async function deleteVenomAnalysis(analysis) {
    const result = await apiBase.simpleDeleteAsync("/venomanalysis", analysis);

    return result.data;
}


export async function getHistoricalAnalysis(specimenID, dailyExtractionID, monthlyPoolID, venomLotID, speciesBatchPoolID) {
    const result = await apiBase.simpleGetAsync("/venomanalysis", { 
        params: { 
            specimenID, 
            dailyExtractionID, 
            monthlyPoolID, 
            venomLotID,
            speciesBatchPoolID
        } 
    });

    return result.data;
}
